import { createReducer } from '../../utils/createReducer.ts';
import { BehaviorState } from '../types.ts';

import {
  BehaviorActions,
  TOGGLE_CHAT,
  TOGGLE_INPUT_DISABLED,
  TOGGLE_MESSAGE_LOADER,
  TURN_OFF_MESSAGE_LOADER,
  TURN_ON_MESSAGE_LOADER,
} from '../actions/types.ts';

const initialState = {
  showChat: false,
  disabledInput: false,
  messageLoader: false
};

const behaviorReducer = {
  [TOGGLE_CHAT]: (state: BehaviorState) => ({ ...state, showChat: !state.showChat}),

  [TOGGLE_INPUT_DISABLED]: (state: BehaviorState) => ({ ...state, disabledInput: !state.disabledInput }),

  [TOGGLE_MESSAGE_LOADER]: (state: BehaviorState) => ({ ...state, messageLoader: !state.messageLoader }),
  
  [TURN_ON_MESSAGE_LOADER]: (state: BehaviorState) => ({ ...state, messageLoader: true }),
  
  [TURN_OFF_MESSAGE_LOADER]: (state: BehaviorState) => ({ ...state, messageLoader: false }),
};

export default (state: BehaviorState = initialState, action: BehaviorActions) => createReducer(behaviorReducer, state, action);
